import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { initTelegramWebApp, getStartParam } from "./telegram/webApp"
import { authenticate, ApiError } from "./api/client"
import { HomePage, CreateRoomPage, JoinRoomPage, LobbyPage, LeaderboardPage, ProfilePage, ResultPage } from "./pages/OtherPages"
import { GamePage } from "./pages/GamePage"
import "./styles/app.css"

/**
 * Runs once per app load (fresh launch OR relaunch via a Telegram deep
 * link), regardless of which route/page happens to be current. This
 * guarantees a `?startapp=join_XXXX` link always redirects to the join
 * flow, even if the Mini App instance was already open on another page.
 */
function AppShell() {
	const navigate = useNavigate()
	const [ready, setReady] = useState(false)
	const [authError, setAuthError] = useState<string | null>(null)

	useEffect(() => {
		authenticate()
			.then(() => {
				const startParam = getStartParam()
				if (startParam?.startsWith("join_")) {
					navigate(`/join/${startParam.replace("join_", "")}`, { replace: true })
				}
			})
			.catch((err) => setAuthError(err instanceof ApiError ? err.message : "Authentication failed"))
			.finally(() => setReady(true))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	if (!ready) return <div className="page loading-page">Loading…</div>
	if (authError) return <div className="page error-page">{authError}</div>

	return (
		<Routes>
			<Route path="/" element={<HomePage />} />
			<Route path="/create" element={<CreateRoomPage />} />
			<Route path="/join" element={<JoinRoomPage />} />
			<Route path="/join/:roomCode" element={<JoinRoomPage />} />
			<Route path="/lobby/:roomCode" element={<LobbyPage />} />
			<Route path="/game/:roomCode" element={<GamePage />} />
			<Route path="/result" element={<ResultPage />} />
			<Route path="/profile" element={<ProfilePage />} />
			<Route path="/leaderboard" element={<LeaderboardPage />} />
		</Routes>
	)
}

export default function App() {
	useEffect(() => { initTelegramWebApp() }, [])
	return (
		<BrowserRouter>
			<AppShell />
		</BrowserRouter>
	)
}
